import includes from 'ramda/src/includes';

export const isIncludeAcc = includes("acc");